import { dashboardDictionary } from "~/lang/en/sections/dashboard"
import { languages } from "~/lang/en/sections/languages"

export default {
  ...languages,
  users: "Users",
  dashboard: {
    ...dashboardDictionary,
  },
}
